const readEnv = (value?: string) => value?.trim();

const oidcSettings = {
  authority: readEnv(process.env.REACT_APP_SSO_authority),
  client_id: readEnv(process.env.REACT_APP_SSO_client_id),
  redirect_uri: readEnv(process.env.REACT_APP_SSO_redirect_uri) || `${window.location.origin}/landing`,
  response_type: readEnv(process.env.REACT_APP_SSO_response_type),
  scope: readEnv(process.env.REACT_APP_SSO_scope),
  post_logout_redirect_uri: readEnv(process.env.REACT_APP_SSO_post_logout_redirect_uri) || window.location.origin,
};

export default oidcSettings;
